__turbopack_context__.v({
  "review-comments-star": "ReviewsMobile-module-scss-module__OiLapq__review-comments-star",
  "review-comments-title": "ReviewsMobile-module-scss-module__OiLapq__review-comments-title",
  "review-layout": "ReviewsMobile-module-scss-module__OiLapq__review-layout",
  "review-layout-mobile": "ReviewsMobile-module-scss-module__OiLapq__review-layout-mobile",
  "review-loadmore": "ReviewsMobile-module-scss-module__OiLapq__review-loadmore",
  "review-modal-body": "ReviewsMobile-module-scss-module__OiLapq__review-modal-body",
  "review-modal-heading": "ReviewsMobile-module-scss-module__OiLapq__review-modal-heading",
  "reviews-comments-star": "ReviewsMobile-module-scss-module__OiLapq__reviews-comments-star",
  "reviews-modal": "ReviewsMobile-module-scss-module__OiLapq__reviews-modal",
  "reviews-title-mobile": "ReviewsMobile-module-scss-module__OiLapq__reviews-title-mobile",
});
